export const ADD_TO_CART="ADD_TO_CART"
export const REMOVE_FROM_CART="REMOVE_FROM_CART"
export const ADD_TO_WISHLIST="ADD_TO_WISHLIST"
export const UPDATE_STATUS="UPDATE_STATUS"
